import * as actionTypes from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  loading: false,
  mediaIds: [],
};

const isLoading = (state, { payload }) => ({
  loading: true,
  mediaIds: [...state.mediaIds, payload.request.data.mediaId],
});

const isEnding = (state, { payload }) => ({
  loading: false,
  mediaIds: state.mediaIds.filter(id => id !== payload.mediaId),
});

export default createReducer(initialState, {
  [actionTypes.DELETE_MEDIA]: isLoading,
  [actionTypes.DELETE_MEDIA_SUCCESS]: isEnding,
  [actionTypes.DELETE_MEDIA_FAILURE]: isEnding,
});
